export const creditsBillingContent = `
Reqqy uses a credit-based system. Your subscription plan includes a monthly credit allocation that resets each billing cycle.

{% card title="Monthly Credits" %}
Each plan includes a set number of monthly credits. Unused monthly credits do not roll over. Your balance resets at the start of each billing cycle.
{% /card %}

{% card title="Top-up Credits" %}
Need more credits? Purchase top-up packs that are added to your balance immediately. Top-up credits are used after your monthly allocation and expire after 12 months.
{% /card %}

{% card title="Credit Consumption" %}
Credits are consumed based on the review mode selected: Quick (1 credit), Standard (3 credits), Deep (5 credits). The credit estimator in the review wizard shows exactly how many credits a run will cost before you submit.
{% /card %}
`;
